import script from "./NotFoundPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./NotFoundPage.vue?vue&type=script&setup=true&lang=ts"

import "./NotFoundPage.vue?vue&type=style&index=0&id=307d28a2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-307d28a2"]])

export default __exports__